import { environment } from '@env/environment';
import { Component, inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { ButtonComponent } from '@isg-one/components';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrl: './login.scss',
  imports: [ButtonComponent],
})
export class Login {
  private readonly oktaAuth = inject(OKTA_AUTH) as OktaAuth;
  envName = environment.name
  async login() {
    await this.oktaAuth.signInWithRedirect({
      originalUri: '/dashboard',
    });
  }
}
